import { render, staticRenderFns } from "./DateTimeValue.vue?vue&type=template&id=c6136162&scoped=true"
import script from "./DateTimeValue.vue?vue&type=script&lang=js"
export * from "./DateTimeValue.vue?vue&type=script&lang=js"
import style0 from "./DateTimeValue.vue?vue&type=style&index=0&id=c6136162&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6136162",
  null
  
)

export default component.exports